/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Connect_ErrorInputs */

const en_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to connect to the server`)
};

const ar_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذر الاتصال بالخادم`)
};

const bn_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সার্ভারের সঙ্গে সংযোগ করা যাচ্ছে না`)
};

const de_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zum Server fehlgeschlagen`)
};

const es_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo conectar al servidor`)
};

const fr_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la connexion au serveur`)
};

const pt_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao conectar ao servidor`)
};

const zh_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接服务器失败`)
};

const tr_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunucuya bağlanılamadı`)
};

const ru_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось подключиться к серверу`)
};

const pl_chat_connect_error = /** @type {(inputs: Chat_Connect_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się połączyć z serwerem`)
};

/**
* | output |
* | --- |
* | "Failed to connect to the server" |
*
* @param {Chat_Connect_ErrorInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_connect_error = /** @type {((inputs?: Chat_Connect_ErrorInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Connect_ErrorInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_connect_error(inputs)
	if (locale === "bn") return bn_chat_connect_error(inputs)
	if (locale === "de") return de_chat_connect_error(inputs)
	if (locale === "es") return es_chat_connect_error(inputs)
	if (locale === "fr") return fr_chat_connect_error(inputs)
	if (locale === "pt") return pt_chat_connect_error(inputs)
	if (locale === "zh") return zh_chat_connect_error(inputs)
	if (locale === "tr") return tr_chat_connect_error(inputs)
	if (locale === "ru") return ru_chat_connect_error(inputs)
	if (locale === "pl") return pl_chat_connect_error(inputs)
	return en_chat_connect_error(inputs)
});